(function () {
  'use strict';
  function start() {
    var notice = document.getElementById('ct-cookie-notice');
    var panel = notice && notice.querySelector('.cookie-content');
    var chat = document.getElementById('ct-global-whatsapp');
    var sales = document.getElementById('ct-sales-popup');
    var scheduled = false;
    function visible(el) { if (!el) return false; var s = getComputedStyle(el); return s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity) > 0; }
    function arrange() {
      scheduled = false;
      var mobile = innerWidth < 768, safe = mobile ? 82 : 24;
      var shown = panel && visible(notice), rect = shown ? panel.getBoundingClientRect() : null;
      var lift = rect ? innerHeight - rect.top + 16 : safe;
      var sr = sales && sales.getBoundingClientRect(), cr = chat && chat.getBoundingClientRect();
      var intersects = function (r) { return rect && r.width > 0 && r.left < rect.right + 12 && r.right > rect.left - 12; };
      var salesBottom = intersects(sr || {width:0}) ? lift : safe;
      if (sales) sales.style.setProperty('--ct-sales-bottom', salesBottom + 'px');
      var chatBottom = intersects(cr || {width:0}) ? lift : safe;
      if (mobile && sales && visible(sales) && sr.width > 0) chatBottom = Math.max(chatBottom, salesBottom + sr.height + 16);
      if (chat) chat.style.setProperty('--ct-float-bottom', chatBottom + 'px');
    }
    function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(arrange); } }
    if (window.ResizeObserver) { var ro = new ResizeObserver(schedule); if (panel) ro.observe(panel); if (sales) ro.observe(sales); }
    if (notice) new MutationObserver(schedule).observe(notice, {attributes:true,attributeFilter:['style','class']});
    if (sales) new MutationObserver(schedule).observe(sales, {attributes:true,attributeFilter:['class']});
    addEventListener('resize', schedule, {passive:true});
    document.addEventListener('ct:consentchange', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
}());

